import { useEffect, useRef } from "react";

/**
 * Manual polling. The dashboard uses this at 30s intervals to keep
 * the metric tiles fresh without dragging in a state library. The
 * caller's callback identity can change between renders without
 * resetting the timer.
 */
export function usePoll(
  callback: () => void | Promise<void>,
  intervalMs: number,
  options: { enabled?: boolean } = {}
): void {
  const { enabled = true } = options;
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) return;
    const tick = () => {
      void savedCallback.current();
    };
    const id = setInterval(tick, intervalMs);
    return () => clearInterval(id);
  }, [enabled, intervalMs]);
}
